import React from 'react';
import PropTypes from 'prop-types';
import {
  CardNumberElement,
  CardExpiryElement,
  CardCVCElement,
  injectStripe
} from 'react-stripe-elements';
import i18n from '../utils/i18n';

const StripeForm = ({ handleSubmit, stripe, buttonDisabled, buttonText }) => (
  <form onSubmit={ ev => handleSubmit(stripe, ev) }>
    <span>
      {i18n.t('payments.CARD_NUMBER')}
      <CardNumberElement />
    </span>
    <span>
      {i18n.t('payments.EXPIRATION_DATE')}
      <CardExpiryElement />
    </span>
    <span>
      {i18n.t('payments.CVC')}
      <CardCVCElement />
    </span>
    <button type="submit" disabled={ buttonDisabled }>
      {buttonText}
    </button>
  </form>
);

StripeForm.propTypes = {
  handleSubmit: PropTypes.func,
  stripe: PropTypes.shape({ createToken: PropTypes.func }),
  buttonDisabled: PropTypes.bool,
  buttonText: PropTypes.string
};

StripeForm.defaultProps = {
  handleSubmit: () => {},
  stripe: null,
  buttonDisabled: false,
  buttonText: ''
};

export default injectStripe(StripeForm);



// WEBPACK FOOTER //
// ./src/components/StripeForm.js